module.exports = __webpack_public_path__ + "img/top_back.f739048f.png";